import clsx from "clsx";
import React from "react";
import HelpDropdown from "web/react/components/navigation/pre-header-bar/help-dropdown";
import LanguageSelector from "web/react/components/navigation/pre-header-bar/language-selector";
import UserDropdown from "web/react/components/navigation/pre-header-bar/user-dropdown";
import CountryOverlay from "web/script/components/overlays/country-overlay";
import { gettext } from "web/script/modules/django-i18n";
import { canUseMembership } from "web/script/modules/utils";
import { AppPreHeaderBarSerializer } from "web/types/serializers";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./pre-header-bar.module.css";

interface PreHeaderBarProps {
    countryInfo: AppPreHeaderBarSerializer["country_info"];
    showCountryPicker: AppPreHeaderBarSerializer["show_country_picker"];
    accountDropdown: AppPreHeaderBarSerializer["account_dropdown"];
    accountText: AppPreHeaderBarSerializer["account_text"];
    accountUrl: AppPreHeaderBarSerializer["account_url"];
    registerUrl: AppPreHeaderBarSerializer["register_url"];
    languageSelector: AppPreHeaderBarSerializer["language_selector"];
}

function PreHeaderBar({
    countryInfo,
    showCountryPicker,
    accountDropdown,
    accountText,
    accountUrl,
    registerUrl,
    languageSelector,
}: PreHeaderBarProps): React.ReactElement {
    function onCountryPickerClick(event): void {
        event.stopPropagation();
        event.preventDefault();

        if (showCountryPicker) {
            const countryOverlay = new (CountryOverlay as any)();
            countryOverlay.appendTo(document.body);
            countryOverlay.open();
        }
    }

    return (
        <div className={styles.preHeaderBar}>
            <div className={clsx(styles.preHeaderBarInner, "hidden-tablet")}>
                {canUseMembership() && (
                    <>
                        <UserDropdown
                            accountDropdown={accountDropdown}
                            accountText={accountText}
                            accountUrl={accountUrl}
                            registerUrl={registerUrl}
                        />
                        <HelpDropdown />
                    </>
                )}
                <button
                    aria-label={gettext("header.country_picker.label")}
                    className={clsx(styles.action, styles.countryPicker, {
                        [styles.actionDisabled]: !showCountryPicker,
                    })}
                    onClick={onCountryPickerClick}
                    type="button"
                >
                    <div className={styles.actionContainer}>
                        {`${countryInfo.country} - ${countryInfo.currency_indicator}`}
                    </div>
                </button>
                {languageSelector.is_shown && (
                    <LanguageSelector
                        calloutText={languageSelector.callout_text}
                        choices={languageSelector.choices}
                        numColumns={languageSelector.num_columns}
                    />
                )}
            </div>
        </div>
    );
}

export default PreHeaderBar;
